var _g, _defs, _mask, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg06BmwSpeedometer5YcShares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 356",
    enableBackground: "new 0 0 290 356",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("line", {
    id: "baseline-1",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 333.5,
    x2: 222,
    y2: 333.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilterew",
    filterUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251,
    id: "_x35_y_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilterew)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1-5y-mask_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 76,
    width: 22,
    height: 251
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_y_1_",
    mask: "url(#_x35_y_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x34_y",
    d: "M73,128h9v199h-9V128z M108,327h9V76h-9V327z M143,327h9V120.85h-9V327z M178,184v143h9V184H178z M60,327h9 V128h-9V327z M95,327h9V76h-9V327z M130,327h9V121h-9V327z M165,327h9V184h-9V327z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_y",
    fill: "#006BB0",
    d: "M222,219v108h-9V219H222z M200,327h9V219h-9V327z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "preferred-pin_1_",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "221.5,220 227,209 290,209  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "common-pin",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "208.5,220 227,36 290,36  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 203 351.7695)",
    fill: "#006BB0",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "10px"
  }, "2020"), /*#__PURE__*/React.createElement("text", {
    id: "head-preferred",
    transform: "matrix(1 0 0 1 12.1396 317.1504)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "je Vorzugsaktie"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.46,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in \u20AC")), /*#__PURE__*/React.createElement("text", {
    id: "kpi-preferred_1_",
    transform: "matrix(1 0 0 1 262.124 204.5234)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "5,75"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-common",
    transform: "matrix(1 0 0 1 262.124 31.5234)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "5,73"), /*#__PURE__*/React.createElement("text", {
    id: "head-common",
    transform: "matrix(1 0 0 1 14.4058 81.1387)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "je Stammaktie"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.19,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in \u20AC")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06BmwSpeedometer5YcShares);
export default __webpack_public_path__ + "static/media/06_BMW_speedometer-5YC-shares.9e292525.svg";
export { ForwardRef as ReactComponent };